<template>
  <div class="container">
    <div style="width: 1260px; margin: 0 auto; display: flex; height: 100%">
      <div class="tab">
        <div class="tab_title"><common-data name="appShortName_29"/></div>
        <!-- <div class="underline"></div> -->
        <ul>
          <li
            v-for="(item, index) in contentList"
            :key="index"
            class="tit-left-item"
            :class="{ active: index == id }"
            @click="selectContent(item)"
          >
            <span>{{ item.name }}</span
            >
          </li>
        </ul>
      </div>
      <div class="content">
        <div class="con-text">
          <div style="box-shadow: 0px 2px 3px 0px rgba(209, 222, 238, 0.9)">
            <div class="text-first">
              <div class="txt-first">
                <div
                  v-for="(item, index) in tabList"
                  :key="index"
                  class="txt-left-item"
                  @click="choosetag(item.tabId)"
                  :class="{ active: tabId == item.tabId }"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="text-txt">
            <div class="wrap">
              <div v-if="id == 0 && tabId == 0">
                
                    <div class="paragraph" >
                      软件按宏观、中观、微观视角梳理对股票影响较大的事件，提供包括个股新闻事件、盈利预测、二级市场、公告事件、机构调研、市场情绪、宏观数据、估值等各个维度的股票开源事件因子。
                    </div>
                    <div class="paragraph" >
                      其中，估值类因子基于文华原创的多因子估值数据库开发得到。
                    </div>
                    <div class="paragraph" >
                      支持查看因子python代码了解因子原理。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/sjyzk1.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph" >
                      自编平台提供了完善的基础代码框架和编写示例，支持自编因子扩展分析。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/kyyzk-2.jpg')"
                    ></BaseBigimg>
              </div>
              <div v-if="id == 0 && tabId == 1">
               
                    <div class="paragraph" >
                      影响股价波动的事件众多且形式多样，但这些事件对股价波动产生了什么方向的影响，影响程度有多大，影响的有效期有多久需要有客观的、可量化的数据来衡量。                    
                    </div>
                    <div class="paragraph">
                      独创的定价因子分析平台通过预设影响事件与股价波动之间的关系对其进行因子化处理，进一步计算出在因子影响下股价涨跌的贝叶斯概率。通过贝叶斯方法计算的股价涨跌概率，考虑到了事件发生且股价上涨/下跌的股票数量在上涨/下跌股票和全部股票中的占比浓度差异，更准确的评估因子对股价涨跌的影响情况。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/bysgl-1.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph" >
                      因子对股价的影响时效也各有不同，股价调整系数计算了事件发生后因子每日对贝叶斯概率的平均影响程度，能够有效评估因子对股价影响的有效期，在有效期内计算股价的最终涨跌概率。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/tzxs-1.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph">
                      结合提供的因子分布图表，了解因子原值的分布特征与各因子得分的出现次数，直观的研究因子对股价波动的影响规律，探究因子与股价变化之间的关系是否符合预设，综合评估因子对股价波动的影响程度和有效期。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/yzfb-1.jpg')"
                    ></BaseBigimg>
              </div>
              <div v-if="id == 0 && tabId == 2">
               
                    <div class="paragraph" >
                      股票价格的波动受到很多因素的影响，同一时间点各个维度的影响事件进行着多空博弈，最终由占据主导的一方驱动股价变动。长期来看，选的股票再好，也有跌的时候；选的股票即使不好，也有涨的时候，你需要对持有的股票资产进行风险控制。                    
                    </div>
                    <div class="paragraph">
                      股票风险控制策略研究，搭建了一个研究股票价格影响事件的分析环境，可以将影响股价变化的事件构建成一个平衡表，每个事件就是一个因子，因子对股票价格产生影响，以此仿真股价变化的过程。可利用因子的变化来把握股价的短期波动，进行风险控制。利空信息出现时临时减仓，利空影响消失后恢复持仓，以此降低成本增厚收益，优化持仓净值。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/jzgl-1.jpg')"
                    ></BaseBigimg>
                   
                    <BaseBigimg
                      :src="require('./imageswh11/jzgl-2.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph">
                      根据风险控制策略的特点，软件汇总报告和个股回测报告中提供了风险控制策略优化净值曲线、无操作持仓的原净值曲线以及交易明细，可以直观了解风险控制对于持仓组合的优化情况，为评估策略有效性提供参考。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/cl1.jpg')"
                    ></BaseBigimg>
                    <BaseBigimg
                      :src="require('./imageswh11/cl2.jpg')"
                    ></BaseBigimg>
              </div>
              
              <div v-if="id == 0 && tabId == 3">
                
                    <div class="paragraph" >
                      通过现有信息选出的一篮子股票，当前股价可能已经完成了上涨，后续会由涨转跌，此时入场并不是一个划算的选择。                    
                    </div>
                    <div class="paragraph">
                      通过资金管理策略，跟踪自选股票池内因子的变化并迅速做出决策，对股票进行择时建仓。当利好信息出现时，买入股票赚取收益；等利好消化后，卖出股票及时出场，将持仓转换为资金，同时实现利益的收割与资金风险管理。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/zjgl-1.jpg')"
                    ></BaseBigimg>
                    <BaseBigimg
                      :src="require('./imageswh11/zjgl-2.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph" >
                      软件提供了资金管理策略的回测表现、收益情况、回撤情况以及交易明细，为评估策略有效性提供参考。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/zjgl-3.jpg')"
                    ></BaseBigimg>
                    <BaseBigimg
                      :src="require('./imageswh11/zjgl-4.jpg')"
                    ></BaseBigimg>
              </div>
              <div v-if="id == 0 && tabId == 4">
                
                    <div class="paragraph" >
                      软件支持自有数据落库，在软件中进行分析和维护，可以与系统数据库联合构建股票事件因子、风险控制策略与资金管理策略，拓展分析深度和广度。                    
                    </div>
                    
                    <BaseBigimg
                      :src="require('./imageswh11/zysjlk-1.jpg')"
                    ></BaseBigimg>
              </div>

              <div v-if="id == 1 && tabId == 0">
                
                    <div class="paragraph" >
                      软件按品种梳理对各个品种影响较大的因素，提供包括宏观、供给、需求、消费等各个维度的期货开源因子，用户可以查看因子python代码了解因子原理。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/KYYZ-1.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph" >
                      自编平台提供了完善的基础代码框架和编写示例，以便用户自编因子扩展分析。因子维度越丰富，对品种的定价描述就越完善。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/KYYZ-2.jpg')"
                    ></BaseBigimg>
              </div>
              <div v-if="id == 1 && tabId == 1">
               
                    <div class="paragraph" >
                      商品的价格变化往往是多重市场因素共同作用导致的，了解每个因素在价格形成中所发挥的作用大小，以及区分它们是噪音还是真正的行情启动因素至关重要。
                    </div>
                    <div class="paragraph" >
                      期货因子分析，对这些因素进行因子化处理，当事件发生时给出价格涨/跌投票，通过涨跌相关性、趋势相关性分析，从因子投票与后续价格的涨跌关系、事件覆盖时段下因子投票的持续性以及投票方向和价格走势的一致程度等，多维度分析因子的有效性。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/DJYZ-1.jpg')"
                    ></BaseBigimg>
              </div>
              <div v-if="id == 1 && tabId == 2">
                
                    <div class="paragraph" >
                      商品价格的形成受到很多因素的影响，而且不同市场阶段驱动价格的因素也不同，再加上商品产业链之间具有很强的价格传导性，因此对商品的价格分析往往牵一发而动全身。
                    </div>
                    <div class="paragraph" >
                      商品期货策略研究，为用户搭建了一个研究商品价格影响因素的分析环境，可以将宏观、供给、需求、消费等各个维度的价格影响因素构建成一个平衡表，通过这些因子对价格的影响来仿真商品价格的形成过程，找到品种价格变化的背后依据。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/DJCL-1.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph" >
                      软件提供策略的回测表现、净值曲线、回撤曲线、策略持仓方向以及因子贡献度展示，可以直观的了解策略对价格的解释程度，研究商品价格的形成机制。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/DJCL-2.jpg')"
                    ></BaseBigimg>
                    
              </div>
              <div v-if="id == 1 && tabId == 3">
                
                    <div class="second">
                      数据分析-可视化的产业数据
                    </div>
                    <div class="paragraph" >
                      以可视化图表形式展示各品种的产业数据，通过时序图和季节性分析图表从横向和纵向角度展示供应端、需求端、库存、基差等数据结构。
                    </div>
                    
                    <BaseBigimg
                      :src="require('./imageswh11/SJFX-1.jpg')"
                    ></BaseBigimg>
                    <BaseBigimg
                      :src="require('./imageswh11/SJFX-2.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph" >
                      对机构持仓数据进行整合，绘制多维度分析图表，透视机构持仓结构、建仓过程，追随主力脚步，踩准行情节拍。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/SJFX-3.jpg')"
                    ></BaseBigimg>
                    <BaseBigimg
                      :src="require('./imageswh11/SJFX-4.jpg')"
                    ></BaseBigimg>
              </div>

              <div v-if="id == 1 && tabId == 4">
               
                    <div class="second">
                      数据扩展1-Excel插件
                    </div>
                    <div class="paragraph" >
                      Excel是用户常用的数据处理分析工具，为了更好的顺应用户使用需求，软件提供Excel插件工具，支持对系统数据库中的产业数据、宏观经济数据、商品行情数据进行导出分析或者二次加工，生成报告、可视化分析。
                    </div>
                    
                    <BaseBigimg
                      :src="require('./imageswh11/SJKZ-1.jpg')"
                    ></BaseBigimg>
                    <div class="second">
                      数据扩展2-自有数据落库
                    </div>
                    <div class="paragraph" >
                      软件也支持用户的自有数据落库，在软件中进行分析和维护，可以与系统数据库联合构建定价因子、定价策略，拓展分析深度和广度。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh11/SJKZ-2.jpg')"
                    ></BaseBigimg>
                    
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="loading" v-if="showloading">
      <img src="../assets/img/loading.gif" alt="" style="position:absolute;top:42%;left:50%;">
    </div> -->
    <!-- <BaseHover :message="message" v-show="!!message" class="basehover" :style="{left:left+'px',top:top+'px'}"></BaseHover>
    <BaseAlert @close="close" v-if="showalert"></BaseAlert> -->
  </div>
</template>
<script>
import axios from "axios";
import Svgg from "../../components/Svgg.vue";
import Basecharts from "../../components/Basecharts.vue";
import BaseHover from "../../components/BaseHover.vue";
import BaseAlert from "../../components/BaseAlert.vue";

export default {
  components: {
    Basecharts,
    BaseHover,
    BaseAlert,
    Svgg,
  },
  watch: {
    // "currentComponent": {
    //   handler: function (newd) {
    //     console.log(newd)
    //     console.log(document.documentElement.getElementsByClassName('img_center')[0])
    //   },
    //   deep:true,
    //   immediate:true,
    // },
    "$route.query.id": {
      handler: function (newd) {
        console.log(newd);
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    console.log(this.$route.query.id);
  },
  data() {
    return {
      id: 0,
      contentList: [
        {
          name: "股票基金风险控制",
          tab: [
            {
              name: "事件因子库",
              tabId: 0,
            },
            // {
            //   name: "股票因子分析",
            //   tabId: 1,
            // },
            {
              name: "风险控制策略研究",
              tabId: 2,
            },
            // {
            //   name: "资金管理策略研究",
            //   tabId: 3,
            // },
            {
              name: "数据扩展",
              tabId: 4,
            },
          ],
          id: 0,
        },
        {
          name: "商品投研",
          tab: [
            {
              name: "开源因子库",
              tabId: 0,
            },
            {
              name: "期货因子分析",
              tabId: 1,
            },
            {
              name: "商品期货策略研究",
              tabId: 2,
            },
            {
              name: "数据分析",
              tabId: 3,
            },
            {
              name: "数据扩展",
              tabId: 4,
            },
          ],
          id: 1,
        },
      ],
      tabList: [],
      tabId: 0,
    };
  },
  mounted() {
    this.selectContent(this.contentList[0]);
  },
  methods: {
    selectContent(item) {
      this.id = item.id;
      this.tabId = 0;
      this.tabList = item.tab;
    },
    choosetag(id) {
      this.tabId = id;
    },
    
  },
};
</script>
<style scoped src="./index.css"></style>
<style scoped>
.trans {
  transform: rotate(180deg);
}
.container {
  padding-top: 50px;
  height: 100%;
  min-height: 400px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=82) no-repeat top,
    url(../../assets/img/bgonepp.jpg) repeat-y center top 1134px;
  text-align: left;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
}
.content {
  color: rgb(132, 133, 135);
  border-radius: 10px 10px 0 0;
  width: 100%;
  height: 100%;
  min-height: 600px;
  /* margin-left: 40px; */
  background: #fff;
  box-shadow: -1px 0px 3px 0px rgba(209, 222, 238, 0.9);
  
  font-size: 17px;
}
.tab ul li {
  width: 140px;
}
/* .tab {
  width: 140px;
}
.tab_title {
  font-size: 20px;
  font-weight: 570;
  line-height: 40px;
  padding-left: 8px;
  color: #323232;
  margin-top: 25px;
}
.underline {
  width: 30px;
  height: 2px;
  background: #323232;
  margin-left: 8px;
}
.tab ul {
  margin-top: 20px;
}
.tab ul li {
  color: #808080;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  width: 125px;
  padding-left: 12px;
  background: transparent;
  cursor: pointer;
  margin-bottom: 10px;
  border-radius: 0 50px 50px 0;
  padding-right: 18px;
}
.tab ul li:hover {
  color: #3b78f7;
 
}
.tab ul li.active {
  color: #3b78f7;
  background-image: linear-gradient(90deg, #f9feff, #e9f6ff, #dfebf7);
  background-image: -moz-linear-gradient(90deg, #f9feff, #e9f6ff, #dfebf7);
  box-shadow: #d1d6e5 1px 1px 5px 2px;

} */
.text-first {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* width: 1096px; */
  margin: 0 60px;
  margin-top: 20px;
}
.text-txt {
  padding-top: 5px;
  font-size: 15px;
  min-height: 600px;
  background: #f6f9fe;
  margin-top: 3px;
  padding-bottom: 40px;
}
.tit-left {
  display: flex;
  flex-direction: row;
}
.right-tip {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 1005px;
  margin: 0 auto;
  cursor: pointer;
}
.right-tip div {
  padding: 2px 4px;
}
/* .right-tip div.active{
  color: white;
  background: #4b63f7;
} */
.tit-left-item {
  cursor: pointer;
  /* padding: 6px 18px; */
  position: relative;
  color: #181818;
}
/* .tit-left-item.active{
  color: #4b63f7;
  border-bottom: 3px solid #4b63f7;
} */
.txt-left-item {
  cursor: pointer;
  margin: 0 18px;
  padding: 3px 0px;
  font-size: 16px;
}
.txt-left-item:hover {
  color: #536b99;
}
.txt-left-item.active {
  color: #5268cd;
  border-bottom: 3px solid #5268cd;
  font-weight: bold;
}
.txt-img {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 1029px;
  margin: 0 auto;
  margin-top: 5px;
}
.base-ech {
  margin: 0px 12px;
  margin-bottom: 26px;
}
.txt-first {
  display: flex;
  flex-direction: row;
  /* margin-left: 50px; */
}
.txt-table {
  margin-top: 5px;
}
</style>